module.exports = __webpack_public_path__ + "img/bitcoin1.9e7dc715.png";